module.exports = __webpack_public_path__ + "static/img/newlogo.663c980.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newlogo.png
// module id = OusZ
// module chunks = 3